/* eslint-disable no-unused-vars */

// Supported social sign-up provider connections
export enum SocialSignUpConnection {
    LINKEDIN = 'linkedin',
    GOOGLE = 'google-oauth2',
    MICROSOFT = 'windowslive',
}

export const SocialSignUpConnectionToLabel: Record<SocialSignUpConnection, string> = {
    [SocialSignUpConnection.LINKEDIN]: 'LinkedIn',
    [SocialSignUpConnection.GOOGLE]: 'Google',
    [SocialSignUpConnection.MICROSOFT]: 'Microsoft',
};
